// Plan v3 blind test r1 (Maya, Kim): the same film or recurring event showed as several cards in one row ("Nightshift
// After Hours" x4). Presentation only: one card per thing, with how many more dates it has. Nothing in the pool changes.

const norm = (s: string | null | undefined) => (s ?? '').toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, ' ').trim()
type Folded = { item: { title: string; venue_name: string | null } }
const keyOf = (c: Folded) => `${norm(c.item.title)}|${norm(c.item.venue_name)}`

/** Cards in order, repeats of the same title at the same venue folded into the first, with the count of the others. */
export function groupRepeats<C extends Folded>(cards: C[]): { card: C; more: number }[] {
  const out: { card: C; more: number }[] = []
  const at = new Map<string, number>()
  for (const c of cards) {
    const k = keyOf(c)
    const i = at.get(k)
    if (i === undefined) { at.set(k, out.length); out.push({ card: c, more: 0 }) } else out[i].more++
  }
  return out
}
